import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import SideBar from '../../commonModules/layouts/SideBar';
import SmsList from './SmsList';
import AlertManagement from './AlertManagement/AlertManagement';
import AgentsList from './AgentsList';
import { fetchProducts } from '../../../../../jsx/actions/productAction'
import { fetchSubscriptions, deleteSubscription } from '../../../../../jsx/actions/subscriptionAction'
import { getProspectList } from '../../../../../jsx/actions/prospectAction'
import { getStoreClients } from '../../../../../jsx/actions/stockInitAction'
import { 
    fetchAgents,
    updateAgent,

    fetchInstallers, 
    updateInstaller,

    fetchSchemas,
    fetchReportSchemas,
    fetchQuotationSchemas,
    fetchSavSchemas, 

    fetchBoxes,
    fetchFreeBoxes,
    fetchLinkedBoxes, 

    fetchCredit,
    fetchCreditList,

    fetchSims,
    fetchSms,
    fetchSmsPaginated,

    fetchAlerts,
    deleteAlert,

    fetchUsers,
    fetchRoles, 
} from '../../../../../jsx/actions/paygAction'
import { getZoneList } from '../../../../../jsx/reducers/paygAdmin/zones';
import { fetchCommercialStocks, fetchCommercialReas } from "../../../../../jsx/actions/commercialReaAction"
import { fetchCommercialReturns } from "../../../../../jsx/actions/commercialReturnAction"
import { fetchSales } from "../../../../../jsx/actions/saleAction"

import SubscriptionsList from './SubscriptionsList';
import InstallersList from './InstallersList';
import SimsList from './SimsList';
import BoxesList from './BoxesList';
import UsersList from './UsersList';
import SchemasList from './SchemasList';
import ExtractList from './ExtractList';
import ImportFiles from './ImportFiles';
import CreditAccount from './CreditAccount';
import Funding from './Funding';
import SuperAdminCode from './SuperAdminCode';
// import Company from './Company';
import Notif from '../../commonModules/interface/Notif';
// Page « Match Produits » masquée : remplacée par le product_id canonique (migration product-mix du 29/09/2026).
// import Matching from './MatchProduct/Matching';
import { HomeRounded, AssignmentRounded, AccountCircleRounded, CollectionsRounded, CommentRounded, AddAlertRounded, PowerRounded, BuildRounded, AccountBoxRounded, CloudDownloadRounded, CloudUploadRounded, AccountBalanceWalletRounded, DomainRounded, RepeatRounded, SimCardRounded, MonetizationOnRounded, CloudUploadOutlined, SettingsRounded } from '@material-ui/icons';
import ImportFilesStocks from './ImportFilesStocks';
import { isEmpty } from 'lodash-es';
import Society from './Society/Society';
import Settings from './Settings/Settings';
import { removeUrlParams } from '../urlParams';

class AdminDashboard extends Component {
    state = { 
        page:"stats",
    }
    componentDidMount = () => {
        this.props.page &&
        this.setState({
            page: this.props.page
        })
        // Lien direct vers la liste des commerciaux (?page=agent) : la fiche est ouverte par AgentsList
        // (?agentId=). Seulement si le menu Commerciaux est accessible à l'utilisateur.
        const requested = new URLSearchParams(window.location.search).get("page")
        if (requested === "agent") {
            const { pageList, configList } = this.props
            const allowed = (Array.isArray(pageList) && pageList.includes("Configuration"))
                || (Array.isArray(configList) && configList.includes("agent"))
            if (allowed) {
                this.setState({ page: "agent" })
            }
            // Traité : on retire `page` pour que la page ne se rouvre pas au remontage
            // (agentId reste, AgentsList le retire une fois la fiche ouverte).
            removeUrlParams(["page"])
        }
    }

    render() {
        const { pageList, configList } = this.props;
        const { page } = this.state;

        const LIST = {
                "stats" : { name : "stats", title: "Home", icon : <HomeRounded color={(page === "home" ? "secondary" : "")} /> },
                "abo" : { name : "abo", title: "Abonnements", icon : <AssignmentRounded  color={(page === "abo" ? "secondary" : "")} /> },
                "agent" : { name : "agent", title: "Commerciaux", icon : <AccountCircleRounded  color={(page === "agent" ? "secondary" : "")} /> },
                "schema" : { name : "schema", title: "Schémas", icon : <CollectionsRounded  color={(page === "schema" ? "secondary" : "")} /> },
                "sim" : { name : "sim", title: "Sim", icon : <SimCardRounded  color={(page === "sim" ? "secondary" : "")} /> },
                "sms" : { name : "sms", title: "SMS", icon : <CommentRounded  color={(page === "sms" ? "secondary" : "")} /> },
                "alert" : { name : "alert", title: "Alerte", icon : <AddAlertRounded  color={(page === "alert" ? "secondary" : "")} /> },
                "box" : { name : "box", title: "Systèmes et Box", icon : <PowerRounded  color={(page === "box" ? "secondary" : "")} /> },
                "installer" : { name : "installer", title: " Techniciens", icon : <BuildRounded  color={(page === "installer" ? "secondary" : "")} /> },
                "users" : { name : "users", title: "Utilisateurs", icon : <AccountBoxRounded  color={(page === "users" ? "secondary" : "")} /> },
                "extract" : { name : "extract", title: "Extract", icon :<CloudDownloadRounded  color={(page === "extract" ? "secondary" : "")} /> },
                "upload" : { name : "upload", title: "Upload", icon :<CloudUploadRounded  color={(page === "upload" ? "secondary" : "")} /> },
                "uploadstore" : { name : "uploadstore", title: "Upload Magasin", icon :<CloudUploadOutlined  color={(page === "uploadstore" ? "secondary" : "")} /> },
                "credit" : { name : "credit", title: "Crédit", icon : <AccountBalanceWalletRounded  color={(page === "credit" ? "secondary" : "")} /> },
                // "funding" : { name : "funding", title: "Financement", icon : <MonetizationOnRounded  color={(page === "funding" ? "secondary" : "")} /> },
                // "company" : { name : "company", title: "Entreprise", icon : <DomainRounded  color={(page === "company" ? "secondary" : "")} /> },
                // "matching" : { name : "matching", title: "Match Produits", icon : <RepeatRounded  color={(page === "matching" ? "secondary" : "")} /> },
                "codesuperadmin" : { name : "codesuperadmin", title: "Code Superadmin", icon : <DomainRounded  color={(page === "codesuperadmin" ? "secondary" : "")} /> },
                "society" : { name : "society", title: "Entreprise", icon : <DomainRounded  color={(page === "society" ? "secondary" : "")} /> },
                "settings" : { name : "settings", title: "Paramètres", icon : <SettingsRounded  color={(page === "settings" ? "secondary" : "")} /> },
        }
        let menu = []
        console.log('====================================');
        console.log({pageList, configList});
        console.log('====================================');
        if (pageList.includes("Configuration")){
            menu = Object.values(LIST)
        } else if ( !isEmpty(configList) ){
            Object.keys(LIST).map( configPage => {
                if (configList.includes(configPage))
                menu.push(LIST[configPage])
            })
        }
        // Gating front best-effort : "settings" visible uniquement pour admin (role != 0),
        // et pour un rôle délégué seulement s'il porte la page 15000_Integrations_Page
        // (traduite en config "settings" par getAccess). Le backend enforce en dur
        // côté domainModel.
        const isAdmin = this.props.userRole && this.props.userRole !== 0;
        if (!isAdmin) {
            menu = menu.filter(item => item.name !== 'settings');
        }

        return (
            <React.Fragment>
                <SideBar menu={menu} page={page} changePage={ (page) => this.setState({ page })} >
                    {this.state.page === "stats" && 
                        <div>
                            <h3>Configuration</h3>
                        </div>
                    }
                    {this.state.page === "sms" && <SmsList {...this.props} />}
                    {this.state.page === "alert" && <AlertManagement {...this.props} />}
                    {this.state.page === "abo" && <SubscriptionsList {...this.props} /> }
                    {this.state.page === "agent" && <AgentsList {...this.props} /> }
                    {this.state.page === "schema" && <SchemasList {...this.props} /> }
                    {this.state.page === "installer" && <InstallersList {...this.props} /> }
                    {this.state.page === "sim" && <SimsList {...this.props} /> }
                    {this.state.page === "box" && <BoxesList {...this.props} /> }
                    {this.state.page === "users" && <UsersList {...this.props} /> }
                    {this.state.page === "extract" && <ExtractList {...this.props} /> }
                    {this.state.page === "upload" && <ImportFiles {...this.props}  /> }
                    {this.state.page === "uploadstore" && <ImportFilesStocks {...this.props} /> }
                    {this.state.page === "credit" && <CreditAccount {...this.props} /> }
                    {this.state.page === "funding" && <Funding /> }
                    {/* {this.state.page === "company" && <Company {...this.props} /> } */}
                    {/* {this.state.page === "matching" && <Matching {...this.props} /> } */}
                    {this.state.page === "codesuperadmin" && <SuperAdminCode {...this.props} /> }
                    {this.state.page === "society" && <Society {...this.props} /> }
                    {this.state.page === "settings" && isAdmin && <Settings />}
                </SideBar>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state){// transform elements from store's state into props in this component
    return {
        configList : state.userAccess.CONFIG,
        pageList : state.userAccess.PAGES,
        userRole: state.auth.user && state.auth.user.role,

        ZONES: state.zones,
        AGENTS: state.agents.agents,
        SUBSCRIPTIONS: state.subscriptions,
        INSTALLERS: state.installers,
        SCHEMAS: state.schemas.ALL,

        BOXES: state.boxes.ALL,
        BOXES_FREE: state.boxes.FREE,

        SMS: state.sms,
        SIMS: state.sims,
        ALERTS: state.alertsManagement,
        
        PRODUCTS: state.inventory.products,

        CREDIT: state.credit.INFOS,
        TRANSACTION_LIST: state.credit.LIST,

        USERS: state.users,
        ROLES: state.roles,

        STATS: state.stats,
        // STATS: state.stats.SCHEMAS, ? from schemasList
        STATS_SUB: state.stats.SUBSCRIPTIONS,

        STATE: state.inventory.requestState,

        COMMERCIAL_REAS: state.inventory.commercialReas,
        COMMERCIAL_STOCKS: state.inventory.commercialStocks,
        COMMERCIAL_RETURNS: state.inventory.commercialReturns,
        SALES: state.inventory.sales,

    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        fetchAgents,
        updateAgent,
        getZoneList,

        fetchBoxes,
        fetchFreeBoxes,
        fetchLinkedBoxes,
        
        fetchCredit,
        fetchCreditList,

        fetchInstallers,
        updateInstaller, 

        fetchSchemas,
        fetchReportSchemas,
        fetchQuotationSchemas,
        fetchSavSchemas,


        fetchSims,
        fetchSms,
        fetchSmsPaginated,
        fetchAlerts,
        deleteAlert,
        getProspectList,
        getStoreClients,

        
        fetchSubscriptions,
        deleteSubscription,
        
        fetchUsers,
        fetchRoles,
        fetchProducts,
        fetchCommercialStocks,
        fetchCommercialReas, 
        fetchCommercialReturns,
        fetchSales,

    }, dispatch)
}
export default connect(mapStateToProps, mapDispatchToProps )(AdminDashboard);